import { API_URL } from './config.js';

export function getSessionToken() {
  return localStorage.getItem('session_token');
}

export function setSessionToken(token) {
  if (token) localStorage.setItem('session_token', token);
  else localStorage.removeItem('session_token');
}

export function getUser() {
  const raw = localStorage.getItem('user');
  return raw ? JSON.parse(raw) : null;
}

export function setUser(user) {
  if (user) localStorage.setItem('user', JSON.stringify(user));
  else localStorage.removeItem('user');
}

export function logout() {
  setSessionToken(null);
  setUser(null);
  window.location.href = '/';
}

export async function apiCall(path, options = {}) {
  const token = getSessionToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers.Authorization = 'Bearer ' + token;

  const response = await fetch(API_URL + path, {
    method: options.method || 'GET',
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined
  });

  if (response.status === 401) { logout(); throw new Error('Session expired'); }
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'HTTP ' + response.status);
  }
  return response.json();
}